import { inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  GuardResult,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { InitialiseService, UserService } from "src/app/services";

export const billingRedirectGuard: CanActivateFn = async (
  snapshot: ActivatedRouteSnapshot,
  _: RouterStateSnapshot
): Promise<GuardResult> => {
  const init = inject(InitialiseService);
  const us = inject(UserService);
  const router = inject(Router);

  const routeGuid = snapshot.params["tenantid"] || "";
  const productId = snapshot.params["productId"] || "";
  const quantity = snapshot.params["quantity"] || "";
  const code = snapshot.queryParams["code"] || "";

  const loggedIn = await init.user();

  if (loggedIn) {
    try {
      const resultRouteGuid = await init.route(routeGuid);

      if (routeGuid !== resultRouteGuid) {
        return router.createUrlTree(
          ["/", resultRouteGuid, "billing", productId, quantity],
          {
            queryParams: code ? { code } : {},
          }
        );
      } else {
        return true;
      }
    } catch (ex) {
      await us.logout();
    }
  }

  let queryParams: any = {
    mode: "checkout",
  };

  if (productId) {
    queryParams["productId"] = productId;
  }
  if (quantity) {
    queryParams["quantity"] = quantity;
  }
  if (code) {
    queryParams["code"] = code;
  }

  router.navigate(["/login"], { queryParams });
  return false;
};
